<template>
  <div
    class="modal"
    :style="showModalBehavior ? 'display: block' : 'display: none'"
  >
    <div class="modal-background"></div>
    <div
      class="modal-card mt-3 mb-3"
      style="
        max-width: 600px;
        min-width: 250px;
        margin: auto;
        height: 100%;
        justify-content: center;
      "
    >
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ type == 1 ? "Choose Items" : "Choose Category" }}
        </p>
        <button
          class="delete"
          aria-label="close"
          @click="closeModalBehavior"
        ></button>
      </header>
      <section style="background: white">
        <div
          class="has-text-white px-5 py-2"
          style="background-color: hsl(348, 100%, 61%)"
          v-if="this.selectedValue.length == 0"
        >
          <i class="fa fa-times-circle mr-2" />
          Plese select at least 1 items
        </div>
        <div class="floating-action-modal">
          <div
            class="pb-2 pt-4 px-5 has-text-grey"
            style="background-color: #f2f2f2"
            v-if="type == 1"
          >
            {{
              `Selected Item (${selectedValue.length} / ${dataSource.length})`
            }}
          </div>
          <div
            v-else
            class="pb-2 pt-4 px-5 has-text-grey"
            style="background-color: #f2f2f2"
          >
            {{
              `Selected Category (${
                !tagData.find((x) => x.value == selectedValue)
                  ? ""
                  : tagData.find((x) => x.value == selectedValue).label
              })`
            }}
          </div>
          <div class="pb-2 pt-4 px-5 has-text-grey-dark">
            <div class="field has-addons">
              <div class="control" style="width: 100%">
                <input
                  v-model="searching"
                  :style="
                    searching.length == 0
                      ? 'border-bottom-right-radius: 4px !important; border-top-right-radius: 4px !important;'
                      : ''
                  "
                  class="input"
                  placeholder="E.g: Index Jisim Badan"
                />
              </div>
              <div class="control" v-show="searching.length > 0">
                <button class="button is-danger" @click="searching = ''">
                  <i class="fa fa-times" />
                </button>
              </div>
            </div>
            <!-- <input v-model="searching" class="input" placeholder="E.g: Index Jisim Badan" /> -->
          </div>
          <div
            class="pb-2 pt-4 px-5 has-text-grey-dark"
            style="border-bottom: 1px solid #c9c9c9"
          >
            <label class="checkbox"
              ><input
                type="checkbox"
                :checked="
                  selectedValue.length != dataSource.length ? false : true
                "
                @click="handleAll"
              /><span class="ml-2">{{
                selectedValue.length != dataSource.length
                  ? "Select All"
                  : "Deselect All"
              }}</span></label
            >
          </div>
        </div>
      </section>
      <section
        class="modal-card-body p-0"
        style="max-height: 400px"
        v-if="type == 1"
      >
        <div
          class="my-2 py-2 px-5"
          :style="
            dataSource.length != index + 1
              ? 'border-bottom: 1px solid; border-color: #f2f2f2'
              : ''
          "
          v-for="(data, index) in source"
          :key="data.value"
        >
          <label class="checkbox has-text-grey-dark is-capitalized">
            <input
              type="checkbox"
              :checked="
                selectedValue.find((x) => x == data.value) ? true : false
              "
              @click="(e) => handleChecked(e, data)"
            />
            <span class="ml-2">{{ data.label }}</span>
          </label>
        </div>
      </section>
      <section class="modal-card-body p-0" style="max-height: 400px" v-else>
        <div class="my-2 py-2 px-5">
          <div class="control">
            <div v-for="data in source" :key="data.value">
              <label class="radio has-text-dark">
                <input
                  type="radio"
                  name="answer"
                  :checked="
                    selectedValue.find((x) => x == data.value) ? true : false
                  "
                  @click="(e) => handleChecked(e, data)"
                />
                <span class="ml-2">{{ data.label }}</span>
              </label>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button is-success"
          :disabled="this.selectedValue.length == 0"
          @click="handleSubmit"
        >
          Save changes
        </button>
        <button class="button" @click="closeModalBehavior">Cancel</button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: "modalBehavior",
  props: [
    "showModalBehavior",
    "closeModalBehavior",
    "dataSource",
    "value",
    "handleUpdate",
    "type",
    "tagData",
  ],
  data() {
    return {
      selectedValue: this.value,
      visibility: {
        show: false,
        name: "",
      },
      searching: "",
      source: [],
    };
  },
  mounted() {
    this.selectedValue = this.value;
    this.source = this.dataSource;
  },
  watch: {
    showModalBehavior() {
      this.selectedValue = this.value;
    },
    value() {
      this.selectedValue = this.value;
    },
    dataSource() {
      this.source = this.dataSource;
    },
    searching() {
      if (this.searching.length > 0) {
        const finding = this.dataSource.filter((x) =>
          x.label.toLowerCase().includes(this.searching)
        );
        this.source = finding;
      } else {
        this.source = this.dataSource;
      }
    },
  },
  methods: {
    handleVisibility(visibility) {
      this.visibility = {
        ...this.visibility,
        show: visibility,
      };
    },
    handleChecked(e, data) {
      const targetStatus = e.target.checked;

      if (this.type == 1) {
        if (targetStatus) {
          let item = [...this.selectedValue, data.value];
          this.selectedValue = item;
        } else {
          let filterItem = this.selectedValue.filter((x) => x != data.value);
          this.selectedValue = filterItem;
        }
      } else {
        this.selectedValue = [data.value];
      }
    },
    handleAll() {
      if (this.selectedValue.length == this.dataSource.length) {
        this.selectedValue = [];
      } else {
        this.selectedValue = this.dataSource.map((x) => {
          return x.value;
        });
      }
    },
    handleSubmit() {
      if (this.selectedValue && this.selectedValue.length > 0) {
        this.handleUpdate("behaviorID", this.selectedValue);
        this.handleVisibility(!this.visibility.show);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/OverallReporting/ModalBehavior.vue